<template>
    <div name="easy-service" class="easy-service">
        <div class="container">
            <div class="section-header">
                <strong class="title">모두를 위한<br>간편하고 안전한 서비스</strong>
                <span class="sub-title">시작부터 끝까지 전과정을 보호자분들과 함께합니다.</span>
                <p class="sub-text">
                    진료 전 부모님 정보 확인, 결제 수단 관리부터<br>
                    진료 후 의료비 결제 내용, 진료 내용과 처방 안내 등<br>
                    전자 문서를 통해 언제 어디서든 확인 가능합니다.</p>
            </div>
            <div class="service-view">
                <div class="carousel-container">
                    <div class="dot-container">
                        <span @click="goToSlide(0)" :class="{ 'active': currentSlide === 0 }"></span>
                        <span @click="goToSlide(1)" :class="{ 'active': currentSlide === 1 }"></span>
                        <span @click="goToSlide(2)" :class="{ 'active': currentSlide === 2 }"></span>
                    </div>

                    <carousel :autoplay="true" :loop="true" :paginationEnabled="false" :autoplay-timeout="5000" :perPage="1" @after-change="onSlideChange"  @page-change="onSlideChange" ref="carousel">
                        <slide v-for="(image, index) in images" :key="index">
                            <img :src="image" alt="모두를 위한 간편하고 안전한 서비스 이미지" />
                        </slide>
                    </carousel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
    name: 'easy-service',
    components: {
        Carousel,
        Slide,
    },
    data() {
        return {
            images: [
                require('../../assets/pc_barocare/img_slider1.png'),
                require('../../assets/pc_barocare/img_slider2.png'),
                require('../../assets/pc_barocare/img_slider3.png'),
            ],
            activeIndex: 0,
            currentSlide: 0
        };
    },

    methods: {
        goToSlide(index) {
            this.currentSlide = index;
            this.$refs.carousel.goToPage(index);
        },
        onSlideChange(index) {
            this.currentSlide = index;
        }
    },
}
</script>

<style scoped>
    .easy-service {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        background: #EBF7FE;
    }
    .easy-service .container{
        position: relative;
        min-width: 960px;
        width: 100%;
        max-width: 1320px;
        height: 660px;
        margin: 0 auto;
        padding: 180px 20px 40px;
        z-index: 1;
    }
    .section-header{
        width: 100%;
    }
    .section-header .title{
        font-family: 'Pretendard';
        font-style: normal;
        font-size: 44px;
        font-weight: 600;
        line-height: 1.6;
        color: #1A1A1A;
    }
    .section-header .sub-title{
        margin-top: 25px;
        display: block;
        font-family: 'Pretendard';
        font-size: 18px;
        font-weight: 600;
        line-height: 1.6;
        color: #1A1A1A;
    }
    .section-header .sub-text{
        margin-top: 11px;
        margin-bottom: 0;
        font-family: 'Pretendard';
        font-style: normal;
        font-size: 18px;
        font-weight: 400;
        line-height: 1.65;
        color: #1A1A1A;
    }
    .sub-text strong{
        font-weight: 600;
    }
    .carousel-container {
        position: absolute;
        left: 56%;
        bottom: 0;
        width: 566px;
        overflow: hidden;
    }
    .dot-container{
        height: 47px;
        margin-left: 205px;
        text-align: center;
    }

    .dot-container span {
        display: inline-block;
        width: 10px;
        height: 10px;
        margin: 5px;
        background-color: #D9D9D9;
        border-radius: 50%;
        cursor: pointer;
    }

    .dot-container span.active {
        width: 34px;
        background-color: #0082EC;
        border-radius: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_barocare/EasyService.vue